import React from "react";
import ReactModal from "react-modal";
import style from "../SendMerchantLink/SendMerchantLink.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import CloseIcon16 from "../../../../assets/svg/icons/common/CloseIcon16";

function ConfirmationModal({ open, onClose, message, onConfirmClick, submitButtonText = "Confirm", cancelButtonText = "Cancel" }) {
  return (
    <ReactModal isOpen={open} className={style.react_modal}>
      <div className={style.header}>
        <ButtonIcon onClick={onClose}>
          <CloseIcon16 />
        </ButtonIcon>
      </div>

      <div className={style.body}>
        <h6>{message}</h6>
      </div>

      <div className={style.footer_modal}>
        <div className={style.button_group}>
          <ButtonIcon textColor="#254FE2" onClick={onClose}>
            {cancelButtonText}
          </ButtonIcon>
          <ButtonIcon
            bgColor={"#E03B24"}
            textColor="#FFF"
            onClick={() => onConfirmClick()}
          >
            {submitButtonText}
          </ButtonIcon>
        </div>
      </div>
    </ReactModal>
  );
}

export default ConfirmationModal;
